<template>
  <div class="main_right">
    <div class="page_info">
      <Breadcrumb class="breadcrumb">
        <BreadcrumbItem>出入库记录</BreadcrumbItem>
      </Breadcrumb>
      <div class="searchBox">
        <div>
          <Select v-model="reqbody.deviceManufacture" style="width:120px;margin-left: 15px;" placeholder="设备厂家" clearable @on-change="search" @on-clear="search">
            <Option v-for="item in deviceManufactureList" :value="item.label" :key="item.label">{{ item.value }}</Option>
          </Select>
          <Select v-model="reqbody.partnerId" style="width:160px" placeholder="合作伙伴" clearable @on-change="search" @on-clear="search">
            <Option v-for="item in partnerList" :value="item.id" :key="item.id">{{ item.partnerName }}</Option>
          </Select>
          <Select v-model="reqbody.status" style="width:160px" placeholder="设备状态" clearable @on-change="search" @on-clear="search">
            <Option v-for="item in statusList" :value="item.code" :key="item.code">{{ item.name }}</Option>
          </Select>
          <Select v-model="reqbody.outType" style="width:160px" placeholder="出库类型" clearable @on-change="search" @on-clear="search">
            <Option v-for="item in outTypeList" :value="item.code" :key="item.code">{{ item.name }}</Option>
          </Select>
        </div>
        <div>
          <Input v-model="reqbody.searchKey" icon="ios-search" placeholder="设备编号" style="width: 200px" @on-click="search" @keyup.13.native="search"/>
          <Button type="ghost" icon="ios-cloud-download-outline" @click="exportDevice" v-if="authList.indexOf('011004') !== -1">导出</Button>
        </div>
      </div>

      <Table border height="520" ref="warehouse_table" :columns="columns" :data="tableData"></Table>
      <page :total="total" show-sizer class="table_page" @on-change="changePageNo" @on-page-size-change="changePageSize" show-total></page>
    </div>

    <modal
      v-model="dialog"
      title="请勿恶意修改"
      @on-ok="confirm"
      @on-cancel="cancel">
        <div style="width:300px;display: block;margin: 0 auto;overflow: hidden;">
          <div style="float: left;line-height: 30px;width: 60px;">合作伙伴：</div>
          <Select v-model="modifyData.partnerId" style="width: 240px;float: left;" placeholder="合作伙伴" clearable >
            <Option v-for="item in partnerList" :value="item.id" :key="item.id">{{ item.partnerName }}</Option>
          </Select>
        </div>
        <div style="width:300px;display: block;margin: 20px auto 0;overflow: hidden;">
          <div style="float: left;line-height: 30px;width: 60px;">商户名：</div>
          <Select v-model="modifyData.merchantId" style="width: 240px;float: left;" placeholder="商户名" clearable >
            <Option v-for="item in merchantList" :value="item.id" :key="item.id">{{ item.merchantName }}</Option>
          </Select>
        </div>
        <div style="width:300px;display: block;margin: 20px auto 0;overflow: hidden;">
          <div style="float: left;line-height: 30px;width: 60px;">出库类型：</div>
          <Select v-model="modifyData.outType" style="width: 240px;float: left;" placeholder="出库类型" clearable >
            <Option v-for="item in outTypeList" :value="item.code" :key="item.code">{{ item.name }}</Option>
          </Select>
        </div>
        <div style="width:300px;display: block;margin: 20px auto 0;overflow: hidden;">
          <div style="float: left;line-height: 30px;width: 60px;">设备状态：</div>
          <Select v-model="modifyData.status" style="width: 240px;float: left;" placeholder="设备状态" clearable >
            <Option v-for="item in statusList" :value="item.code" :key="item.code">{{ item.name }}</Option>
          </Select>
        </div>
        <div style="width: 300px;display: block;margin: 20px auto 0;overflow: hidden;">
          <div style="float: left;line-height: 30px;width: 60px;">备&nbsp;&nbsp;&nbsp;&nbsp;注：</div>
          <Input v-model="modifyData.memo" style="width: 240px;float: left;" :maxlength=32 />
        </div>
    </modal>
  </div>
</template>

<script>
import {httpUrl} from '../../api'
import {errorHandler} from '../../util/errorHandler'
import {nSuccess} from '../../util/notice'
import {getAuthStr} from '../../util/bus'

export default {
  name: 'warehouse-record',
  data () {
    return {
      authList: '',
      dialog: false,
      partnerList: [],
      merchantList: [],
      deviceManufactureList: [
        {label: '大麦物联', value: '大麦物联'},
        {label: '宇视', value: '宇视'},
        {label: '大华', value: '大华'}
      ],
      statusList: [{
        code: '1',
        name: '入库'
      }, {
        code: '2',
        name: '出库'
      }, {
        code: '3',
        name: '故障'
      }, {
        code: '4',
        name: '作废'
      }],
      outTypeList: [{
        code: '1',
        name: '销售'
      }, {
        code: '2',
        name: '借货'
      }, {
        code: '3',
        name: '投资'
      }, {
        code: '4',
        name: '赠送'
      }],
      reqbody: {
        deviceManufacture: '',
        partnerId: '',
        status: '',
        outType: '',
        searchKey: '',
        pageSize: 10,
        pageNo: 1
      },
      modifyData: {
        id: '',
        status: '',
        outType: '',
        memo: '',
        merchantId: '',
        merchantName: '',
        partnerId: '',
        partnerName: '',
      },
      columns: [{
        title: '设备厂家',
        align: 'center',
        key: 'deviceManufacture'
      }, {
        title: '设备编号',
        key: 'deviceNo',
        align: 'center'
      }, {
        title: '设备型号',
        key: 'deviceType',
        align: 'center'
      }, {
        title: '合作伙伴',
        key: 'partnerName',
        align: 'center'
      }, {
        title: '商户名',
        key: 'merchantName',
        align: 'center'
      }, {
        title: '入库时间',
        key: 'inputTime',
        align: 'center'
      }, {
        title: '出库时间',
        key: 'outputTime',
        align: 'center'
      }, {
        title: '出库类型',
        key: 'outTypeText',
        width: 120,
        align: 'center'
      }, {
        title: '状态',
        key: 'state',
        width: 80,
        align: 'center'
      }, {
        title: '备注',
        key: 'memo',
        align: 'center'
      }, {
        title: '操作',
        key: 'operation',
        width: 80,
        align: 'center',
        render: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'edit'
              },
              style: {
                color: '#2d8cf0',
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  this.modifyWarehouse(params.row)
                }
              }
            }),
            h('span', {
              style: {
                color: '#2d8cf0',
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  this.modifyWarehouse(params.row)
                }
              }
            }, '修改')
          ])
        }
      }],
      tableData: [],
      total: 0,
      deleteDevId: {},
      batchId: {
        ids: ''
      }
    }
  },
  created () {
    this.authList = getAuthStr()
    this.getPartnerList()
    this.getBusinessList()
    this.getWarehousePage()
  },
  methods: {
    // 获取合作伙伴列表
    getPartnerList () {
      this.$axios.post(`${httpUrl.url}/manage/partner/getList`, this.reqbody)
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data
            this.partnerList = list
          }
        })
        .catch(errorHandler('获取数据失败'))
    },
    // 获取商户列表
    getBusinessList () {
      this.$axios.post(`${httpUrl.url}/manage/merchant/getList`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data
            this.merchantList = list
          }
        })
        .catch(errorHandler('获取数据失败'))
    },
    getWarehousePage () {
      this.$axios.post(`${httpUrl.url}/manage/ioRecord/getPage`, this.reqbody)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            let list = data.list
            list.map(v => {
              if (v.status === '1') {
                v.state = '入库'
              } else if (v.status === '2') {
                v.state = '出库'
              } else if (v.status === '3') {
                v.state = '故障'
              } else {
                v.state = '作废'
              }
              if (v.outType === '1') {
                v.outTypeText = '销售'
              } else if (v.outType === '2') {
                v.outTypeText = '借货'
              } else if (v.outType === '3') {
                v.outTypeText = '投资'
              } else if (v.outType === '4') {
                v.outTypeText = '赠送'
              }
            })
            if (this.authList.indexOf('011002') !== -1) {
              list.map(v => {
                v.authStatusM = true
              })
            } else {
              list.map(v => {
                v.authStatusM = false
              })
            }
            this.tableData = list
            this.total = data.total
          }
        })
        .catch(errorHandler('获取数据失败'))
    },
    updateWarehousePage () {
      this.merchantList.map(v => {
        if (v.id === this.modifyData.merchantId) {
          this.modifyData.merchantName = v.merchantName
        }
      })
      this.partnerList.map(v => {
        if (v.id === this.modifyData.partnerId) {
          this.modifyData.partnerName = v.partnerName
        }
      })
      this.$axios.post(`${httpUrl.url}/manage/ioRecord/update`, this.modifyData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.getWarehousePage()
          }
        })
        .catch(errorHandler('获取数据失败'))
    },
    changePageNo (m) {
      this.reqbody.pageNo = m
      this.getWarehousePage()
    },
    changePageSize (n) {
      this.reqbody.pageSize = n
      this.getWarehousePage()
    },
    search () {
      this.reqbody.pageNo = 1
      this.getWarehousePage()
    },
    // 导出
    exportDevice () {
      let exportUrl = `${httpUrl.url}/manage/ioRecord/export?searchKey=${this.reqbody.searchKey}&partnerId=${this.reqbody.partnerId}&status=${this.reqbody.status}`
      this.downloadFile('', exportUrl)
    },
    downloadFile (fileName, href) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      eleLink.href = href
      eleLink.click()
    },
    modifyWarehouse (row) {
      this.dialog = true
      this.modifyData.id = row.id
      this.modifyData.outType = row.outType
      this.modifyData.status = row.status
      this.modifyData.memo = row.memo
      this.modifyData.merchantId = row.merchantId
      this.modifyData.partnerId = row.partnerId
    },
    cancel () {
      this.dialog = false
    },
    confirm () {
      this.dialog = false
      this.updateWarehousePage()
    },
  }
}
</script>

<style scoped>
  .main_right {
    min-width: 780px;
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }

  .page_info {
    margin: 15px;
    background-color: #fff;
  }
  .searchBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .table_page {
    text-align: right;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/warehouse-management/warehouse-record.vue